const ROUTE_MODULE_MAP: Record<string, string> = {
  "/admin/dashboard": "dashboard",
  "/admin/orders": "orders",
  "/admin/delivery": "delivery",
  "/admin/customers": "customers",
  "/admin/users": "users",
  "/admin/products": "products",
  "/admin/billing": "billing",
  "/admin/settings": "settings",
  "/admin/zones": "zones",
  "/admin/payment-methods": "payment_methods",
  "/admin/schedule": "schedule",
  "/admin/conversations": "conversations",
};

export class PermissionUtil {
  static get(): Array<{ module: string; actions: string[] }> {
    try {
      const raw = localStorage.getItem("permissions");
      if (!raw || raw === "*") return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  static hasFullAccess(): boolean {
    const raw = localStorage.getItem("permissions");
    if (!raw) return false;
    if (raw === "*") return true;
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.includes("*") : false;
    } catch {
      return false;
    }
  }

  static can(module: string, action: string): boolean {
    if (this.hasFullAccess()) return true;
    const perms = this.get();
    const mod = perms.find((p) => p.module === module);
    return mod ? mod.actions.includes(action) : false;
  }

  static canRead(module: string) {
    return this.can(module, "read");
  }
  static canCreate(module: string) {
    return this.can(module, "create");
  }
  static canUpdate(module: string) {
    return this.can(module, "update");
  }
  static canDelete(module: string) {
    return this.can(module, "delete");
  }

  static getLandingRoute(): string {
    const priority = [
      "/admin/dashboard",
      "/admin/delivery",
      "/admin/orders",
      "/admin/conversations",
    ];
    for (const route of priority) {
      const module = ROUTE_MODULE_MAP[route];
      if (!module || this.canRead(module)) return route;
    }
    return "/admin/dashboard";
  }
}
